import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../reducers/store';
import { Link, useLocation } from 'react-router-dom';
import { StateUserParams } from '../../../types/users/usersParams';
import moment from 'moment'
import toast from 'react-hot-toast';
import { actionDeleteUser, actionFetchUsers } from '../../../actions/users';
import './viewUsers.css'
import { AddRounded, CloseRounded, DeleteRounded, DoNotDisturbAltRounded, EditRounded } from '@mui/icons-material';
import { Button, ImageBuffer, Loader, PageHeader, Pagination } from '../../../components';
import { UsersMainTableHeader } from '../../../utils/constants';
import { users } from '../../../assets';
import { actionFetchProfiles } from '../../../actions/profile';

interface DeletePostParams {
  detailId: string;
  firstName: string;
}

const ViewUsers = () => {
  const dispatch                                              = useDispatch<AppDispatch>();
  const location                                              = useLocation();
  const searchParams                                          = new URLSearchParams(location.search);
  const page                                                  = searchParams.get("page") || 1
  const {isLoading, getAllUsers, numberOfPages, totalNumber}  = useSelector((state: RootState) => state.userList);
  const { getAllProfiles }                                    = useSelector((state: RootState) => state?.profileList)
  const [allPosts, setAllPosts]                               = useState<StateUserParams[]>(getAllUsers);
  const [isOpen, setIsOpen]                                   = useState<{ [key: number]: boolean }>({})
  // const [page, setPage]                                    = useState<number>(1);

  const handleClick = (index: number) => () => {
    setIsOpen(prev => ({ [index]: !prev[index]}))
  }
  
  const handleDeletePost = ({detailId, firstName}: DeletePostParams) => {
    if (window.confirm(`Are you sure you want to delete this user ${firstName}?`)) {
      // Dispatch the deletePost action here
      dispatch(actionDeleteUser({detailId}))
        .then(() => {
          setAllPosts(allPosts.filter(post => post._id !== detailId));
          // Show success toast after successfully deleting the post
          toast.success('User deleted successfully');
        })
        .catch((error) => {
          // Handle any errors that occur during the deletion process
          toast.error('Error deleting post: ' + error.message);
        });
    }
  };
  
  useEffect(() => {
    dispatch(actionFetchUsers({page})); // You can pass the page number as needed
  }, [dispatch, page]);

  useEffect(() => {
    dispatch(actionFetchProfiles({page}))
  }, [page, dispatch])

  if(!allPosts?.length && !isLoading) return (
    <>
      <div className='empty-profile-card-wrapper'>
        <div className='empty-profile-card-header'>
          <span><DoNotDisturbAltRounded /></span>
          <h1> No Users Found </h1>
        </div>
        <Button buttonWrapper="button-wrapper" linkButton linkTo="/users/create-user" linkClass="link-wrapper" linkName="create user" />
      </div>
    </>
  )

  return (
    <>
      <title>Users</title>
      <PageHeader title="Users" description="Welcome to the Users" download="Download Report" />
      <div className='table-main-wrapper'>
        <div className='table-header'>
          <h3>Users</h3>
          <Button buttonWrapper="button-wrapper" linkButton linkTo="users/create-users" linkClass="link-wrapper" linkName="View all" />
        </div>
        
        {isLoading ? <Loader /> : (
          <table className='main-table'>
            <thead>
              <tr>
                {UsersMainTableHeader.map((option, index) => (
                  <th key={index}>{option.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {allPosts?.map((detail, index) => {
                const profile  = getAllProfiles?.find((profile: any) => profile.userId === detail._id);
                const profileImage = profile?.selectedFile || users;
                const phone = profile?.phoneNumber;
                const dob = profile?.dateOfBirth;
                const sex = profile?.sex;
                const verification = detail?.isVerified === false ? "not verified" : "verified";
                
              return (
                <tr key={index}>
                  <td data-cell="image">
                  <div className="table-image">
                    {isLoading ? <Loader /> : (
                      <ImageBuffer src={profileImage} alt='user img' index={index} />
                    )}
                  </div>
                </td>
                  <td data-cell="first name">{detail?.firstName}</td>
                  <td data-cell="middle name">{detail?.middleName}</td>
                  <td data-cell="last name">{detail?.lastName}</td>
                  <td data-cell="emailAddress">{detail?.emailAddress}</td>
                  <td data-cell="username">{detail?.username}</td>
                  <td data-cell="phone">{phone}</td>
                  <td data-cell="date of birth">{dob}</td>
                  <td data-cell="sex">{sex}</td>
                  <td data-cell="verified">{verification}</td>
                  <td data-cell="created">{moment(detail.createdAt).format('YYYY-MM-DD')}</td>
                  <td data-cell="updated">{moment(detail.createdAt).format('YYYY-MM-DD')}</td>
                  <td data-cell="edit">
                    <div  className={isOpen[index] ? 'button-option active' : 'button-option'}>
                      <button className='button-option-head' onClick={handleClick(index)}>{isOpen[index] ? (<span><CloseRounded /></span>) : (<span><AddRounded /></span>)}</button>
                      <div className='button-menu-option'>
                        <Link to={`/users/edit-user/${detail._id}`} className='button-menu-detail'>
                          <EditRounded />
                          <span>Edit user</span>
                        </Link>
                        <button className='button-menu-detail' onClick={() => handleDeletePost({ detailId: detail._id, firstName: detail.firstName }) }>
                          <DeleteRounded />
                          <span>Delete</span>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              )})}
            </tbody>
          </table>
        )}

        <Pagination actionGet={actionFetchUsers} page={page} numberOfPages={numberOfPages} totalNumber={totalNumber} />
      </div>
    </>
  )
}

export default ViewUsers